/* 🤖 this file was generated by svg-to-ts */
export const iconSimplePlus: {
  name: 'simple_plus';
  data: string;
} = {
  name: 'simple_plus',
  data: `<svg width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M15,7 L9,7 L9,1 C9,0.447 8.552,0 8,0 C7.448,0 7,0.447 7,1 L7,7 L1,7 C0.448,7 0,7.447 0,8 C0,8.553 0.448,9 1,9 L7,9 L7,15 C7,15.553 7.448,16 8,16 C8.552,16 9,15.553 9,15 L9,9 L15,9 C15.552,9 16,8.553 16,8 C16,7.447 15.552,7 15,7"/></svg>`,
};
